import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentRiskAreaDto, IncidentEventTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-incidentriskarea-container',
  templateUrl: './incidentriskarea-container.component.html',
  styleUrls: ['./incidentriskarea-container.component.scss']
})
export class IncidentriskareaContainerComponent implements OnInit {

 
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentRiskAreas$: Observable<IncidentRiskAreaDto[]>;
  eventTypes$: Observable<IncidentEventTypeDto[]>;
  loading: boolean;
  isLoadingIncidentRiskArea$: Observable<boolean>;
  isLoadingEventType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingIncidentRiskArea$ = this.gatwayFacade.isLoadingGateway("IncidentRiskArea");
    this.isLoadingEventType$ = this.gatwayFacade.isLoadingGateway("IncidentEventType");

    this.incidentRiskAreas$ = this.gatwayFacade.loadGateway("IncidentRiskArea");
    this.eventTypes$ = this.gatwayFacade.loadGateway("IncidentEventType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentRiskArea(deletedValue: any) {
    this.gatwayFacade.remove("IncidentRiskArea", deletedValue);
  }


// this method control both the create and update

  onSubmitIncidentRiskArea(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentRiskAreas;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllIncidentRiskArea = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentRiskArea.push(pullData[i]);
    }
  }

// check if the addAllIncidentRiskArea array is not empty, then dispatch the data to the store
   if(addAllIncidentRiskArea.length > 0) {
    this.gatwayFacade.add('IncidentRiskArea', addAllIncidentRiskArea);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('IncidentRiskArea', allUpdates, ['id']);
  }

   }

}
